import { render, staticRenderFns } from "./CardDescription.vue?vue&type=template&id=38a48fcd"
import script from "./CardDescription.vue?vue&type=script&lang=ts"
export * from "./CardDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports